import { FlashMessageSubscriptionDetailsDto } from '../../../dto/flashsubscriptiondetails/flashmessagedetails';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface FlashSubscriptionDetailsResponse extends MiddlewareAPIResponse
{
    getFlashSubscriptionDetailsResponseDto(): FlashMessageSubscriptionDetailsDto;
}

export class FlashSubscriptionDetailsResponseDtoImpl extends MiddlewareDtoImpl implements FlashSubscriptionDetailsResponse
{
    private getFlashSubscriptionDetailsDto : FlashMessageSubscriptionDetailsDto;

    getFlashSubscriptionDetailsResponseDto(): FlashMessageSubscriptionDetailsDto
    {
        return this.getFlashSubscriptionDetailsDto;
    }

    setFlashSubscriptionDetailsResponseDto(getFlashSubscriptionDetailsDto: FlashMessageSubscriptionDetailsDto)
    {
        this.getFlashSubscriptionDetailsDto = getFlashSubscriptionDetailsDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashsubscriptiondetails/getsubscriptiondetailsresponse.tsx